/* «Actualizar ubicación y pernocte» en la ONLY BITRENES de Lautaro.
 *
 * Lautaro Díaz (Satelital), 19/10/2026: «NECESITO QUE HAYA UN BOTON QUE
 * ACTUALIZE LAS POSICIONES Y QUE LOS PERNOCTES DE CADA CHOFER SE CARGUEN EN
 * LA COLUMNA CORRESPONDIENTE: MAÑANA 20-10 CUANDO LLEGUE A LA OFICINA QUIERO
 * APRETAR ESE BOTON Y QUE ME ACTUALIZE LA POSICION Y ME DIGA DONDE
 * PERNOCTO». El pernocte va con la fecha de la mañana: «PERNOCTE 20-10» es
 * dónde paró del 19 al 20 («el tipo se detiene el 19 pero arranca el 20»).
 *
 * ── QUIÉN HACE QUÉ ──────────────────────────────────────────────────────────
 *
 * FlotaBot calcula (`/api/satelital/pernoctes`, módulo `pernocte` del bot):
 * para cada interno, dónde está ahora —la misma foto que HUB.UBICACION— y
 * dónde estuvo detenido más tiempo entre las 20:00 del día anterior y las
 * 08:00 («EN VIAJE · 06:00 <lugar>» si no paró dos horas). Acá sólo se
 * escribe, en ARRIBOS BITREN y SALIDAS BITREN, cuando él aprieta.
 *
 * ── QUÉ SE ESCRIBE ──────────────────────────────────────────────────────────
 *
 * Cada renglón con un interno en TRA (o una patente: la busca FlotaBot; los
 * FLT no se buscan):
 *   · UBICACIÓN ACTUALIZADA pasa a dónde está ahora, pisando lo que había:
 *     es la actualizada. Si FlotaBot no tiene ubicación, queda lo que había.
 *     Una fórmula no se pisa: ya se actualiza sola.
 *   · la columna cuyo título es «PERNOCTE dd-mm» con la fecha de hoy recibe
 *     dónde paró a la noche, sólo si está vacía: un pernocte que él escribió
 *     no se toca (ni uno que escribió el botón antes: se distingue igual de
 *     mal, y dos veces el mismo día da lo mismo). Si la hoja no tiene esa
 *     columna, ahí no se escribe ningún pernocte y se dice.
 *
 * ── SUS COMBINADAS ──────────────────────────────────────────────────────────
 *
 * El bitren va en dos renglones, y en SALIDAS BITREN casi todo está
 * combinado de a dos (TRA, UBICACIÓN ACTUALIZADA, los pernoctes), con el
 * valor en la de arriba. Si la celda a escribir está en una combinada de UNA
 * columna, se escribe en su ancla, y una sola vez: el primer renglón (el de
 * arriba) gana. Si el de abajo tiene OTRO tractor en TRA, lo suyo no entra en
 * esa celda: se dice la fila y cuál quedó (`compartidas`), para que no
 * desaparezca del resumen. Si la combinada agarra otras columnas (UBICACIÓN
 * y la actualizada juntas), escribir en la ancla pisaría otra columna: no se
 * escribe y se dice la fila.
 *
 * ── QUÉ TEXTO SE REEMPLAZÓ ──────────────────────────────────────────────────
 *
 * Que UBICACIÓN ACTUALIZADA se pise está bien, pero se dice qué decía: en la
 * revisión, un «TALLER» escrito a mano pasó a «Rio Grande, Tierra del Fuego»
 * y la pantalla sólo dijo «Actualicé N bitrenes». Lo que se escribe no
 * cambia; cambia lo que se cuenta (`ubicaciones` de cada hoja, y
 * `reemplazosDeUbicacion`).
 *
 * Sin ruido: una celda vacía o que queda igual (sin mirar mayúsculas,
 * tildes ni espacios) no es un reemplazo. Y cada mañana el botón pisa lo que
 * él mismo escribió el día anterior; eso va contado y plegado, para que no
 * tape lo otro.
 *
 * Lo del botón NO se reconoce por la forma, y no es por no haberlo probado.
 * Lo que escribe es el nombre de la geocerca si el tractor está en una, y si
 * no «Localidad, Provincia». Con las posiciones de 08 a 09 h de los 50
 * tractores 10xx del 06 al 19/10 (692 mañanas), 611 caen en una geocerca y
 * 448 de esos nombres están todos en mayúsculas («RIO GRANDE», «AZUL»,
 * «GARAYALDE», «LAS FLORES», «DORREGO»): igual que lo que él escribe a mano
 * en UBICACIÓN («RGD», «LAPRIDA», «GARAYALDE», «LAS FLORES», «B.JUAREZ»).
 * «Parece escrito a mano» por la forma habría dejado a la vista casi todo lo
 * que escribió el botón. Entonces se recuerda qué escribió el botón para
 * cada tractor de la planilla (`recordarUbicaciones`; lo guarda la pantalla)
 * y es «del botón» sólo lo que sigue diciendo eso mismo. Lo demás —lo
 * escrito a mano, o lo que no se sabe— va a la vista.
 *
 * Se lee por el título y no por la posición, como `shared/torrecillas`.
 * Todo acá es puro: lo prueban los tests con datos inventados.
 */

import { mapaCombinadas } from "./planillaCombinadas";
import { normalizarPatente } from "./planillaHub";
import { pelado } from "./torrecillas";

const txt = (v) => String(v ?? "").replace(/\s+/g, " ").trim();

/* ── Una zona con sentido (Leonel, ticket 506) ──────────────────────────────
 *
 * «Hice una zona que se llama (SALIO DE DORREGO), […] que lo identifique esa
 * zona cuando va para el sur y cuando viene a Bs As, o sea va a depender de
 * la planilla si la subo a salidas o arribos». El camión pasa por esa
 * geocerca en los dos sentidos: lo que dice para dónde va es la hoja.
 *
 * Qué zonas son y qué texto lleva cada sentido lo decide FlotaBot (su tabla
 * `zonas_sentido.ZONAS_CON_SENTIDO`): a la unidad que está en una le manda
 * `por_sentido` = {salidas, arribos}. Acá sólo se elige por el nombre de la
 * hoja, con la misma regla que el bot (`zonas_sentido.sentido_de`): dice
 * SALIDA → salidas; dice ARRIBO → arribos; ninguna o las dos → no se sabe, y
 * va el lugar de siempre (el nombre de la zona). */
export function sentidoDeHoja(nombre) {
  const p = pelado(nombre);
  const sal = p.includes("SALIDA");
  const arr = p.includes("ARRIBO");
  if (sal === arr) return null;
  return sal ? "salidas" : "arribos";
}

/* El texto de `campo` («ubicacion_actual», «ubicacion_planilla») de una
   unidad de FlotaBot para la hoja `nombre`: el de su sentido si está en una
   zona con sentido, y si no, el de siempre. */
export function lugarParaHoja(u, campo, nombre) {
  if (!u || typeof u !== "object") return "";
  const base = txt(u[campo]);
  const sentido = sentidoDeHoja(nombre);
  const elegido = base && sentido && u.por_sentido && typeof u.por_sentido === "object"
    ? txt(u.por_sentido[sentido]) : "";
  return elegido || base;
}

/* Las tres formas de patente de la base (`PATENTE` de `planillaHub`). */
const PATENTE = /^([A-Z]{3}\d{3}|[A-Z]{2}\d{3}[A-Z]{2}|[A-Z]{3}\d{4})$/;

/* Lo que dice TRA → la clave que entiende FlotaBot: el interno sin ceros
   adelante, la patente normalizada, o "" (FLT, vacío, dos juntos). Lo mismo
   que `pernocte.clave_de` del bot. */
export function claveDeTra(v) {
  const t = txt(v);
  if (/^\d{1,5}$/.test(t)) return t.replace(/^0+/, "");
  const p = normalizarPatente(t);
  return PATENTE.test(p) ? p : "";
}

/* «TR» es como se llama en la hoja ARRIBOS de su ARRIBOS Y CORTES (la de
   furgones de TC, desde el 21/10: `shared/arribosFurgones`); en las de
   bitrenes es TRA. */
const TRA = ["TRA", "TR", "TRAC", "TRACTOR"];

/* `{fila, tra, ubic}` del encabezado (en las primeras seis filas) con TRA y
   la columna cuyo título pelado es `titulo`, o null. */
function encabezadoCon(hoja, titulo) {
  const celdas = hoja?.celdas || [];
  for (let i = 0; i < Math.min(celdas.length, 6); i++) {
    let tra;
    let ubic;
    (celdas[i] || []).forEach((v, j) => {
      const p = pelado(v);
      if (tra === undefined && TRA.includes(p)) tra = j;
      if (ubic === undefined && p === titulo) ubic = j;
    });
    if (tra !== undefined && ubic !== undefined) return { fila: i, tra, ubic };
  }
  return null;
}

/* Con UBICACIÓN ACTUALIZADA: la del botón. */
export const encabezadoUbicacion = (hoja) => encabezadoCon(hoja, "UBICACIONACTUALIZADA");

/* Con UBICACIÓN, la fija: la que escribe el job de las 08:00 del bot y la
   que se completa al agregar renglones (`shared/ubicacionAlAgregar`). */
export const encabezadoUbicacionFija = (hoja) => encabezadoCon(hoja, "UBICACION");

/* La columna «PERNOCTE dd-mm» (también «20/10» o «20-10-2026») del día de
   `fecha` (AAAA-MM-DD) en la fila del encabezado, o -1. */
export function columnaPernocte(encabezado, fecha) {
  const [, m, d] = String(fecha || "").split("-").map(Number);
  return (encabezado || []).findIndex((v) => {
    const r = /^PERNOCTE\s*(\d{1,2})\s*[-/.]\s*(\d{1,2})(?:\s*[-/.]\s*\d{2,4})?$/.exec(txt(v).toUpperCase());
    return Boolean(r) && Number(r[1]) === d && Number(r[2]) === m;
  });
}

/* Los índices de las hojas de arribos y salidas donde se puede escribir. */
export function hojasParaActualizar(datos) {
  return (datos?.hojas || []).flatMap((h, i) => {
    const n = pelado(h?.nombre);
    return (n.includes("ARRIBO") || n.includes("SALIDA")) && encabezadoUbicacion(h) ? [i] : [];
  });
}

/* Las claves que se le piden a FlotaBot: sin repetir, en el orden de la hoja. */
export function clavesDeLaPlanilla(datos) {
  const out = [];
  for (const i of hojasParaActualizar(datos)) {
    const h = datos.hojas[i];
    const enc = encabezadoUbicacion(h);
    for (const r of (h.celdas || []).slice(enc.fila + 1)) {
      const k = claveDeTra(r?.[enc.tra]);
      if (k && !out.includes(k)) out.push(k);
    }
  }
  return out;
}

const unicos = (xs) => [...new Set(xs)];

/* Escribe en la hoja lo que contestó FlotaBot (`unidades`, por clave).
   Devuelve `{hoja, actualizados, sinDatos, sinPernocte, pernocteYaEstaba,
   sinColumnaPernocte, tapadas, compartidas, conFormula, ubicaciones}`; la
   hoja que entra no se toca. `actualizados` son los renglones donde se
   escribió algo (`{fila, clave}`, la fila como se ve); `tapadas`, las filas
   donde una combinada de varias columnas no dejó escribir; `compartidas`,
   los renglones cuyo tractor no entró porque la celda combinada ya era de
   otro (`{fila, clave, ancla, de}`: la fila de la ancla y de quién quedó);
   `ubicaciones`, cada celda de UBICACIÓN ACTUALIZADA que se escribió
   (`{fila, clave, antes, ahora}`, la fila de la celda). */
export function aplicarUbicacionYPernocte(hoja, unidades, fecha) {
  const salida = {
    hoja, actualizados: [], sinDatos: [], sinPernocte: [], pernocteYaEstaba: 0,
    sinColumnaPernocte: false, tapadas: [], compartidas: [], conFormula: 0, ubicaciones: [],
  };
  const enc = encabezadoUbicacion(hoja);
  if (!enc) return salida;
  const celdas = (hoja.celdas || []).map((r) => [...(r || [])]);
  const colP = columnaPernocte(celdas[enc.fila], fecha);
  const mapa = mapaCombinadas(hoja.combinadas);
  // Cada celda se escribe una vez: de qué tractor quedó («r,c» → clave).
  const usadas = new Map();
  const tapadas = new Set();
  const compartidas = new Map();
  const sinDatos = [];
  const sinPernocte = [];
  let hayTractores = false;

  // Dónde se escribe (r, c): la celda, la ancla de su combinada de una
  // columna, o null si la tapa una combinada de varias columnas.
  const destino = (r, c) => {
    const rg = mapa.get(`${r},${c}`);
    if (!rg) return { r, c };
    return rg.c0 === c && rg.c1 === c ? { r: rg.r0, c } : null;
  };
  const poner = (d, v) => {
    while (celdas[d.r].length <= d.c) celdas[d.r].push("");
    celdas[d.r][d.c] = v;
  };
  // La celda `d` ya la tomó otro renglón: si es otro tractor, se anota.
  const yaEsDe = (d, r, clave) => {
    const de = usadas.get(`${d.r},${d.c}`);
    if (de === undefined) return false;
    if (de !== clave && !compartidas.has(r)) compartidas.set(r, { fila: r + 1, clave, ancla: d.r + 1, de });
    return true;
  };

  for (let r = enc.fila + 1; r < celdas.length; r++) {
    const clave = claveDeTra(celdas[r][enc.tra]);
    const u = clave ? unidades?.[clave] : null;
    if (!u) continue;
    hayTractores = true;
    const lugar = lugarParaHoja(u, "ubicacion_actual", hoja?.nombre);
    const pernocte = txt(u.pernocte?.texto);
    if (!lugar && !pernocte) {
      sinDatos.push(clave);
      continue;
    }
    let escribio = false;
    if (lugar) {
      const d = destino(r, enc.ubic);
      if (!d) tapadas.add(r + 1);
      else if (!yaEsDe(d, r, clave)) {
        usadas.set(`${d.r},${d.c}`, clave);
        const antes = txt(celdas[d.r][d.c]);
        if (antes.startsWith("=")) salida.conFormula += 1;
        else {
          poner(d, lugar);
          salida.ubicaciones.push({ fila: d.r + 1, clave, antes, ahora: lugar });
          escribio = true;
        }
      }
    }
    if (colP >= 0 && !pernocte) sinPernocte.push(clave);
    if (colP >= 0 && pernocte) {
      const d = destino(r, colP);
      if (!d) tapadas.add(r + 1);
      else if (!yaEsDe(d, r, clave)) {
        usadas.set(`${d.r},${d.c}`, clave);
        if (txt(celdas[d.r][d.c])) salida.pernocteYaEstaba += 1;
        else {
          poner(d, pernocte);
          escribio = true;
        }
      }
    }
    if (escribio) salida.actualizados.push({ fila: r + 1, clave });
  }
  return {
    ...salida,
    hoja: { ...hoja, celdas },
    sinDatos: unicos(sinDatos),
    sinPernocte: unicos(sinPernocte),
    sinColumnaPernocte: hayTractores && colP < 0,
    tapadas: [...tapadas],
    compartidas: [...compartidas.values()],
  };
}

/* El libro entero: `{datos, resultados}`, un resultado por hoja de arribos o
   salidas (`{nombre, cambio, …}` de `aplicarUbicacionYPernocte`). Las demás
   hojas quedan como estaban. */
export function actualizarPlanilla(datos, unidades, fecha) {
  const cuales = hojasParaActualizar(datos);
  const resultados = [];
  const hojas = (datos?.hojas || []).map((h, i) => {
    if (!cuales.includes(i)) return h;
    const r = aplicarUbicacionYPernocte(h, unidades, fecha);
    resultados.push({ ...r, nombre: h.nombre, cambio: r.actualizados.length > 0 });
    return r.hoja;
  });
  return { datos: { ...datos, hojas }, resultados };
}

const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;

const lista = (n) => (n.length === 1 ? String(n[0]) : `${n.slice(0, -1).join(", ")} y ${n[n.length - 1]}`);

/* Lo que dice la pantalla al terminar: «Actualicé 12 bitrenes; 2 sin datos:
   1044, 1031.» y una línea por cada cosa que quedó como estaba. Se cuentan
   tractores, no renglones: el que está en las dos hojas (llegó y vuelve a
   salir) es uno. */
export function resumenActualizacion(resultados, fecha) {
  const rs = resultados || [];
  const n = unicos(rs.flatMap((r) => r.actualizados.map((a) => a.clave))).length;
  const sinDatos = unicos(rs.flatMap((r) => r.sinDatos));
  const lineas = [];
  let primera = n ? `Actualicé ${plural(n, "bitren", "bitrenes")}` : "No actualicé ningún bitren";
  if (sinDatos.length) primera += `; ${sinDatos.length} sin datos: ${sinDatos.join(", ")}`;
  lineas.push(`${primera}.`);
  const sinPernocte = unicos(rs.flatMap((r) => r.sinPernocte)).filter((k) => !sinDatos.includes(k));
  if (sinPernocte.length) lineas.push(`Sin pernocte: ${sinPernocte.join(", ")}.`);
  const ya = rs.reduce((s, r) => s + r.pernocteYaEstaba, 0);
  if (ya) {
    lineas.push(ya === 1
      ? "1 pernocte ya estaba escrito y quedó como estaba."
      : `${ya} pernoctes ya estaban escritos y quedaron como estaban.`);
  }
  const [, m, d] = String(fecha || "").split("-");
  for (const r of rs) {
    if (r.sinColumnaPernocte) {
      lineas.push(`${r.nombre} no tiene la columna PERNOCTE ${d}-${m}: ahí no escribí pernoctes.`);
    }
  }
  const formulas = rs.reduce((s, r) => s + r.conFormula, 0);
  if (formulas) {
    lineas.push(formulas === 1
      ? "1 celda de UBICACIÓN ACTUALIZADA tiene una fórmula y quedó como estaba."
      : `${formulas} celdas de UBICACIÓN ACTUALIZADA tienen una fórmula y quedaron como estaban.`);
  }
  for (const r of rs) {
    const t = [...r.tapadas].sort((a, b) => a - b);
    if (!t.length) continue;
    lineas.push(`${r.nombre}, ${t.length === 1 ? "fila" : "filas"} ${lista(t)}: una celda combinada tapa `
      + `la ubicación o el pernocte; ${t.length === 1 ? "quedó como estaba" : "quedaron como estaban"}.`);
  }
  for (const r of rs) {
    for (const c of [...(r.compartidas || [])].sort((a, b) => a.fila - b.fila)) {
      lineas.push(`${r.nombre}, fila ${c.fila}: el ${c.clave} está en una celda combinada con la fila `
        + `${c.ancla}, y ahí quedó lo del ${c.de}.`);
    }
  }
  return lineas;
}

/* El mismo texto sin mirar mayúsculas, tildes ni espacios: «Azul» y «AZUL»
   no son un reemplazo, y no se pierde nada. */
const comoTexto = (v) => txt(v).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
const igual = (a, b) => comoTexto(a) === comoTexto(b);

/* Qué texto se reemplazó en UBICACIÓN ACTUALIZADA: `{aLaVista, delBoton}`,
   cada uno `{hoja, fila, clave, antes, ahora}` en el orden de las hojas.
   Ni las celdas que estaban vacías ni las que quedan igual. `memoria` es lo
   que el botón escribió la última vez para cada clave (`recordarUbicaciones`):
   si la celda sigue diciendo eso, el reemplazo es del botón sobre lo suyo y
   va plegado; si dice otra cosa, o no hay memoria, va a la vista. */
export function reemplazosDeUbicacion(resultados, memoria) {
  const m = memoria || {};
  const aLaVista = [];
  const delBoton = [];
  for (const r of resultados || []) {
    for (const u of r.ubicaciones || []) {
      if (!txt(u.antes) || igual(u.antes, u.ahora)) continue;
      // Sin memoria para esa clave no es igual a nada: `antes` no está vacío.
      (igual(u.antes, m[u.clave]) ? delBoton : aLaVista).push({ hoja: r.nombre, ...u });
    }
  }
  return { aLaVista, delBoton };
}

/* La memoria con lo que se acaba de escribir: para cada clave, el texto que
   quedó en su UBICACIÓN ACTUALIZADA. Las demás claves quedan: el tractor que
   hoy no tuvo datos sigue con lo que el botón le escribió antes. */
export function recordarUbicaciones(memoria, resultados) {
  const m = { ...(memoria || {}) };
  for (const r of resultados || []) {
    for (const u of r.ubicaciones || []) m[u.clave] = u.ahora;
  }
  return m;
}

/* Lo que dice la pantalla de los reemplazos: `{titulo, lineas, plegado}`,
   con `plegado` = `{resumen, lineas}` o null. Sin ningún reemplazo, null. */
export function textosReemplazos({ aLaVista = [], delBoton = [] } = {}) {
  if (!aLaVista.length && !delBoton.length) return null;
  const linea = (x) => `${x.hoja}, fila ${x.fila} (${x.clave}): decía «${x.antes}», ahora «${x.ahora}».`;
  const cuantas = plural(delBoton.length, "ubicación", "ubicaciones");
  return {
    titulo: aLaVista.length ? "En UBICACIÓN ACTUALIZADA reemplacé:" : "",
    lineas: aLaVista.map(linea),
    plegado: delBoton.length
      ? {
        resumen: aLaVista.length
          ? `Y ${cuantas} que había puesto este botón.`
          : `En UBICACIÓN ACTUALIZADA reemplacé ${cuantas} que había puesto este botón.`,
        lineas: delBoton.map(linea),
      }
      : null,
  };
}
